import React from 'react';
import { Breadcrumb } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet';
import './Act.css';
import Footer from '../../Footer';
import { useTranslation } from 'react-i18next';

const ControlCRS = () => {
   const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
   const { t, i18n } = useTranslation();

   return (
      <div>
         <Helmet>
            <title>{t('Contrôle Réglementaire de Sécurité (CRS) - Professional Inspectors')}</title>
            <meta
               name="description"
               content={t("Découvrez nos services de Contrôle Réglementaire de Sécurité (CRS). Contrôle des appareils à pression de vapeur, gaz, ouvrages de transport de gaz, installations de gaz, installations électriques industrielles, appareils de levage, ascenseurs, monte-charges, moyens de prévention et lutte contre les incendies.")}
            />
            <meta
               name="keywords"
               content={t("Contrôle CRS, Contrôle Réglementaire de Sécurité, appareils à pression de vapeur, gaz, ouvrages de transport de gaz, installations de gaz, installations électriques industrielles, appareils de levage, ascenseurs, monte-charges, moyens de prévention incendie, Professional Inspectors")}
            />
         </Helmet>

         <div className="wrapper_CTL_z">
            <div className="container_15">
               <Breadcrumb separator=">">
                  <Breadcrumb.Item href="/">{t('Accueil')}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t('Contrôle CRS')}</Breadcrumb.Item>
               </Breadcrumb>
               <div className="row">
                  <div className="pic service_cover">
                     <img src="images/CRS1.jpg" className="img-fluid intro_image" />
                  </div>
                  <div className="col-sm-6 strategic CRS">
                     <h3>{t('Contrôle Réglementaire de Sécurité (CRS)')}</h3>
                     <p>
                           <li>{t('Contrôle des appareils à pression de vapeur A1')}</li>
                           <li>{t('Contrôle des appareils à pression de gaz A2')}</li>
                           <li>{t('Contrôle des ouvrages de transport de gaz combustibles par canalisation A3')}</li>
                           <li>{t('Contrôle des installations de gaz dans les domaines industriels B1')}</li>
                           <li>{t('Contrôle des installations électriques dans les domaines industriels B2')}</li>
                           <li>{t('Contrôle des appareils de levage et des ascenseurs et monte-charges B3')}</li>
                           <li>{t('Contrôle des moyens de prévention et de lutte contre les incendies')}</li>
                     </p>
                  </div>
               </div>
            </div>
            <section className="solutions-area" id="services">
               <div className="container">
                  <div className="section-title">
                     <span className="sub-title">{t('Autres Activités')}</span>
                     <h2>{t('Domaine d\'Application')} :</h2>
                     <p>{t('La société « PROFESSIONAL INSPECTORS » assure le contrôle et l’inspection dans les domaines suivants :')}</p>
                  </div>
               </div>
               <main className="page-content-C">
                  <div className="card CND">
                     <div className="content">
                        <h2 className="title">{t('Contrôle Non Destructif (CND)')}</h2>
                        <p className="copy"></p>
                        <a href="/controlCND">
                           <button className="btn">{t('Détails')}</button>
                        </a>
                     </div>
                  </div>
                  <div className="card RSC">
                     <div className="content">
                        <h2 className="title">{t('Réception et Suivi de Construction (RSC)')}</h2>
                        <p className="copy"></p>
                        <a href="/controlRSC">
                           <button className="btn">{t('Détails')}</button>
                        </a>
                     </div>
                  </div>
               </main>
            </section>
            <Footer />
         </div>
      </div>
   );
};

export default ControlCRS;
